import { getPermalinkRouteRedirect } from "../../utils/sessionStorageHelper";

export const getPermalinkRouteRedirectLocation = () => getPermalinkRouteRedirect() || '/';